import { render } from "./SystemSetting.vue?vue&type=template&id=b32d74d6&ts=true"
import script from "./SystemSetting.vue?vue&type=script&lang=ts"
export * from "./SystemSetting.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__